<template>
    <div class="message-header-wrap">
        <el-tabs :value="tabs" @tab-click="handleClick">
            <el-tab-pane  v-for="(item, index) in data" :key="index" :name="item.value">
                <el-badge :value="messageNum[item.value]" v-if="!item.hidden" slot="label" :max="99" :hidden="messageNum[item.value]==0" class="message-header-wrap-badge">
                    <span class="label">{{item.label}}</span>
                </el-badge>
            </el-tab-pane>
        </el-tabs>
		<div @click="toMessage" class="gengduo">
			<span>查看更多</span>
			<span>></span>
		</div>
		<!-- <message-content @clseMask="clseMask" :messageNum="messageNum" :tabData='data' v-if="tabIndex==0" :tabIndex="0"></message-content> -->
		<message-content @clseMask="clseMask" :messageNum="messageNum" :tabData='data'  :tabIndex="1"></message-content>
		<!-- <message-content @clseMask="clseMask" :messageNum="messageNum" :tabData='data'  v-if="tabIndex==2" :tabIndex="2"></message-content> -->
    </div>
</template>
<script>
import messageContent from './messageContent.vue'
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
		messageNum: {
		    default: ''
		},
        data: {
            type: Array,
            default: () => []
        }
    },
	computed:{
	
	},
	
	components:{
		messageContent
	},
    mounted() {
        this.$nextTick(() => {
			
        })
    },
    data() {
        return {
            activeName: 'total',
			tabIndex:0,
        }
    },
    methods: {
        handleClick(value,a,b) {
            this.tabIndex=this.data[value.index].index
        },
		toMessage(ite) {
			this.clseMask()
			this.$router.push({
				path:  this.staticPath + "message"
			})
		},
		clseMask(){
			this.$emit('closeMask')
		}
    },
    watch: {
        value: {
            immediate: true,
            handler(news) {
                this.tabs = news
            }
        }
    }
}
</script>
<style lang="less">
.message-header-wrap{
	position: relative;
    .el-tabs__item {
        height: auto;
        line-height: normal;
        padding: 10px 20px 6px;
        .message-header-wrap-badge {
            height: 100%;
            .label {
                padding: 6px 0;
                box-sizing: border-box;
                display: block;
            }
        }
    }
	.gengduo{
		position: absolute;
		top: 16px;
		right: 0;
		cursor:pointer;
	}
}

</style>
